import { _ as s } from "./index.es421.js";
import { i as a } from "./index.es416.js";
var e = s, o = a, t = Object.prototype, n = t.hasOwnProperty, i = t.propertyIsEnumerable, m = e(/* @__PURE__ */ function() {
  return arguments;
}()) ? e : function(r) {
  return o(r) && n.call(r, "callee") && !i.call(r, "callee");
}, u = m;
export {
  u as i
};
//# sourceMappingURL=index.es285.js.map
